import { useState, memo, useEffect } from "react";
import { ButtonGroup, Button} from "@mui/material";
import { Box, MenuItem, Select, Typography } from "@mui/material";
import newExcel from "../../../../assets/images/FileXls.svg";
import HeatMapTable from "./orHeatMapWeek";
import HeatMapWeekActualVsProduction from "./orHeatMapWeekActualVsProduction";
import OrTrendChartView from "./OrTrendChartView";
import OrLineFill from "./orLineFill";
import CustomButton from "Samarth Module/components/buttons/CustomButton";
import "./components.css";

const VALID_VIEWS = ["OR Trend", "OR% HeatMap", "OR Line Fill", "Actual vs Production"];

const OrTrendChart = ({ tblView, exportORTrendChart }) => {
  const or_trend_week = localStorage.getItem("or_trend_week")
  
  const [view, setView] = useState(() => {
    const stored = localStorage.getItem('or_trend_chart');
    // Fall back to default if stored value is stale or invalid
    return VALID_VIEWS.includes(stored) ? stored : "OR Trend";
  });
  const [viewChangeKey, setViewChangeKey] = useState(0);
  const [groupingSelection, setGroupingSelection] = useState(or_trend_week || "Factory");
  const [lineFillThreshold, setLineFillThreshold] = useState(90);
  const [selectionType, setSelectionType] = useState('Week');

  useEffect(() => {
    setSelectionType('Week');
  }, [view]);

  const chartGroupView = (val) => {
    setGroupingSelection(val)
    localStorage.setItem("or_trend_week", val)
  }

  const chartView = (val) => {
    // Only increment key if switching TO "OR Trend" from a different view
    if (val === "OR Trend" && view !== "OR Trend") {
      setViewChangeKey(prev => prev + 1);
    }
    setView(val)
    localStorage.setItem("or_trend_chart", val)
  }

  const handleExportToExcel = () => {
    if (exportORTrendChart) {
      exportORTrendChart(groupingSelection);
    }
  }

  return (
    <div className={view === "OR Trend" ? "trend-chart" : "trend-chart-details"} style={{ position: 'relative' }}>
      <Box>
        <Box>
          <Box sx={{
            display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid #e0e0e0",
          }}
            style={{
              paddingBottom: '7px',
              marginBottom: '12px',
              marginTop: '-5px'
            }}
          >
            <Typography variant='h6' sx={{ fontSize: "14px", fontWeight: 700 }}>OR Trend</Typography>
            <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
              {view === "OR Line Fill" &&
                <Select
                  size='small'
                  value={lineFillThreshold}
                  onChange={(e) => setLineFillThreshold(e.target.value)}
                  sx={{ fontSize: "11px", height: "30px", minWidth: "90px", position: 'relative' }}
                >
                  <MenuItem sx={{ padding: '5px', fontSize: '12px' }} value={80}>80</MenuItem>
                  <MenuItem sx={{ padding: '5px', fontSize: '12px' }} value={85}>85</MenuItem>
                  <MenuItem sx={{ padding: '5px', fontSize: '12px' }} value={90}>90</MenuItem>
                  <MenuItem sx={{ padding: '5px', fontSize: '12px' }} value={95}>95</MenuItem>
                </Select>
              }
              <Select
                size='small'
                value={selectionType}
                onChange={(e) => setSelectionType(e.target.value)}
                sx={{ fontSize: "11px", height: "30px", minWidth: "90px", position: 'relative' }}
              >
                <MenuItem sx={{ padding: '5px', fontSize: '12px' }} value={'Week'}>Week</MenuItem>
                <MenuItem sx={{ padding: '5px', fontSize: '12px' }} value={'Month'}>Month</MenuItem>
              </Select>
              {view !== "OR Trend" &&
                <Select
                  size='small'
                  value={groupingSelection}
                  onChange={(e) => chartGroupView(e.target.value)}
                  sx={{ fontSize: "11px", height: "30px", minWidth: "90px", position: 'relative' }}
                >
                  <MenuItem sx={{ padding: '5px', fontSize: '12px' }} value='Factory'>Factory</MenuItem>
                  <MenuItem sx={{ padding: '5px', fontSize: '12px' }} value='BG'>BG</MenuItem>
                  <MenuItem sx={{ padding: '5px', fontSize: '12px' }} value='SmallC'>SmallC</MenuItem>
                  <MenuItem sx={{ padding: '5px', fontSize: '12px' }} value='Format'>Format</MenuItem>
                  <MenuItem sx={{ padding: '5px', fontSize: '12px' }} value='Basepack'>Basepack</MenuItem>
                  <MenuItem sx={{ padding: '5px', fontSize: '12px' }} value='CBU'>CBU</MenuItem>
                  <MenuItem sx={{ padding: '5px', fontSize: '12px' }} value='Site Code'>Site Code</MenuItem>
                </Select>
              }
              <ButtonGroup size="small" sx={{ height: "30px" }}>
                <Button
                  sx={{ fontSize: '11px', textTransform: 'none', px: 1.2 }}
                  variant={view === "OR Trend" ? "contained" : "outlined"}
                  onClick={() => chartView("OR Trend")}
                >
                  OR Trend
                </Button>
                <Button
                  sx={{ fontSize: '11px', textTransform: 'none', px: 1.2 }}
                  variant={view === "OR% HeatMap" ? "contained" : "outlined"}
                  onClick={() => chartView("OR% HeatMap")}
                >
                  OR HeatMap
                </Button>
                <Button
                  sx={{ fontSize: '11px', textTransform: 'none', px: 1.2 }}
                  variant={view === "OR Line Fill" ? "contained" : "outlined"}
                  onClick={() => chartView("OR Line Fill")}
                >
                  OR Line Fill
                </Button>
                <Button
                  sx={{ fontSize: '11px', textTransform: 'none', px: 1.2 }}
                  variant={view === "Actual vs Production" ? "contained" : "outlined"}
                  onClick={() => chartView("Actual vs Production")}
                >
                  Planned vs Produced
                </Button>
              </ButtonGroup>
              <div style={{ display: 'flex', columnGap: '10px' }}>
                <CustomButton icon={newExcel} label="Export" type="mm-save" onClick={handleExportToExcel} />
              </div>
            </Box>
          </Box>
        </Box>

        {/* Chart or Details */}
        {view === "OR Trend" ? (
          <OrTrendChartView key={viewChangeKey} tblView={tblView} selectionType={selectionType} />
        ) : view === "Actual vs Production" ? (
          <Box sx={{ fontSize: "12px", color: "#666", p: 2, pb: 0 }}>
            <HeatMapWeekActualVsProduction tblView={tblView} groupingSelection={groupingSelection} selectionType={selectionType}/>
          </Box>
        ) : view === "OR% HeatMap" ? (
          <Box sx={{ fontSize: "12px", color: "#666", p: 2, pb: 0 }}>
            <HeatMapTable tblView={tblView} groupingSelection={groupingSelection} selectionType={selectionType}/>
          </Box>
        ) : view === "OR Line Fill" ? (
          <Box sx={{ fontSize: "12px", color: "#666", p: 2, pb: 0 }}>
            <OrLineFill tblView={tblView} groupingSelection={groupingSelection} thresholdValue={lineFillThreshold} selectionType={selectionType}/>
          </Box>
        ) : (
          <Box sx={{ fontSize: "12px", color: "#666", p: 2, pb: 0 }}>
            <HeatMapTable tblView={tblView} groupingSelection={groupingSelection} selectionType={selectionType}/>
          </Box>
        )}
      </Box>
    </div>
  );
};

export default memo(OrTrendChart);
